import {useMediaQuery} from "@material-ui/core"
import {useStore} from "../Store"
import {useTheme} from "../hooks"

const red = `color:#f50057`
const green = `color:#00c853`
const blue = `color:#2962ff`

export default function StepsMessage(locale = `ja`) {
  const {
    store: {themeColor},
  } = useStore()
  const theme = useTheme(themeColor)
  const isMobile = useMediaQuery(theme.breakpoints.down(`xs`))
  const message = {
    ja: [
      {
        page: `TREND_RANKING`,
        element: `.app`,
        intro: `ガイドツアーへようこそ！<br />
              <hr />
              SimilarChartは、特定の株価や為替通貨の予測値を形状が酷似している<br />
              過去のチャートデータから算出する事ができます。<br />
              それでは早速、SimilarChartの主要な操作方法について見ていきましょう！`,
      },
      {
        page: `TREND_RANKING`,
        element: `.senarioTable`,
        intro: `トレンドランキングとは、各銘柄株価や各為替通貨の変動傾向を<br />
                過去の酷似したチャートから評価してランキング化したものです。<br />`,
        position: isMobile ? `auto` : `bottom`,
      },
      {
        page: `TREND_RANKING`,
        element: `.senarioTerm`,
        intro: `期間を変更すると、評価に使用した過去チャートのデータ期間を変更できます。`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `TREND_RANKING`,
        element: `.senarioCategory`,
        intro: `分類(比較業種)を変更すると、評価対象の銘柄の範囲を変更できます。<br/>
                ×を押して選択解除すると全業種の比較に変更できます。`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `TREND_RANKING`,
        element: `.senarioTrend`,
        intro: `トレンドを変更すると、評価する変動傾向の向きを変更できます。`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `TREND_RANKING`,
        element: `.senarioBrand`,
        intro: `銘柄・為替通貨を選択すると、その銘柄・為替通貨の過去の酷似チャートを表示できます。`,
        position: isMobile ? `auto` : `bottom`,
      },
      {
        page: `SIMILAR_CHART`,
        element: `.target`,
        intro: `同様に、任意の銘柄・為替通貨の酷似チャートも表示できます。<br/>
                銘柄を選択してみましょう！<br />
                銘柄コードもしくは銘柄名のどちらからでも指定する事ができます。`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `SIMILAR_CHART`,
        element: `.term`,
        intro: `次にチャートの期間を選択しましょう！`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `SIMILAR_CHART`,
        element: `.baseDate`,
        intro: `最後にチャートの基準日を選択しましょう！<br />
                こちらの基準日から上記の期間、遡ったチャート形状が比較対象となり、<br />
                酷似したチャートの上位トップ10の正規化したチャート形状が表示されます。<br />
                また、同時に予測したいメイン銘柄のチャートも表示されます。`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `SIMILAR_CHART`,
        element: `.category`,
        intro: `比較対象をフィルタリングする事も可能です。<br />
                ・33業種<br />
                ・ETF（上場投資信託）<br />
                ・REIT（不動産投資信託）<br />
                <span style=${red}>未選択の場合は、全カテゴリーが対象となります</span>`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `SIMILAR_CHART`,
        element: `.trendIcon`,
        intro: `主要なチャート形状に対する類似度を確認する事ができます。<br />
                カラーは、傾向を示しています。<br />
                <span style=${red}>赤色：上昇トレンド</span><br />
                <span style=${green}>緑色：下降トレンド</span><br />
                <span style=${blue}>青色：もみ合い</span>`,
        position: isMobile ? `auto` : `left`,
        returnToTop: true,
      },
      {
        page: `SIMILAR_CHART`,
        element: `.rankingIcon`,
        intro: `チャート形状の類似度が高い上位トップ10を確認する事ができます。<br />`,
        position: isMobile ? `auto` : `left`,
      },
    ],
    en: [
      {
        page: `TREND_RANKING`,
        element: `.app`,
        intro: `Welcom to guide tour！<br />
              <hr />
              SimilarChart can calculate the forecast value of a specific stock price or exchange currency<br />
              based on past chart data with similar shapes.<br />
              Now let's get to know the main operations of SimilarChart!`,
      },
      {
        page: `TREND_RANKING`,
        element: `.senarioTable`,
        intro: `Trend rankings are sorted scores of equities or currencies,<br />
                which are evaluated by trend similarity of past charts of them.`,
        position: isMobile ? `auto` : `bottom`,
      },
      {
        page: `TREND_RANKING`,
        element: `.senarioTerm`,
        intro: `If selecting a term, you can brows other a ranking,<br/>
                which has the term condition which is of past charts.`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `TREND_RANKING`,
        element: `.senarioCategory`,
        intro: `You can select a category to brows a ranking of equities<br />
                which are filtered by the category.`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `TREND_RANKING`,
        element: `.senarioTrend`,
        intro: `By selecting trend, you can brows a ranking of selected trend.`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `TREND_RANKING`,
        element: `.senarioBrand`,
        intro: `If you select a brand in the ranking, you can brows similar<br />
                charts of it.`,
        position: isMobile ? `auto` : `bottom`,
      },
      {
        page: `SIMILAR_CHART`,
        element: `.target`,
        intro: `Also you can brows any similar charts like the senario rankings.<br />
              You can specify by either the stock code or the stock name.`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `SIMILAR_CHART`,
        element: `.term`,
        intro: `Next, let's select the chart term!`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `SIMILAR_CHART`,
        element: `.baseDate`,
        intro: `Finally, let's select the base date of the chart!<br />
              The chart shapes traced back from the reference date for the above period will be compared,<br />
              Shows the top 10 most normalized chart shapes for a very similar chart.<br />
              At the same time, the chart of stock you want to forecast is also displayed.`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `SIMILAR_CHART`,
        element: `.category`,
        intro: `You can also filter the comparison target.<br />
              ・33Industories<br />
              ・ETF<br />
              ・REIT<br />
              <span style=${red}>If not selected, all categories will be targeted.</span>`,
        position: isMobile ? `auto` : `right`,
      },
      {
        page: `SIMILAR_CHART`,
        element: `.trendIcon`,
        intro: `The similarity of the main stock to each chart shape is displayed.<br />
              The color shows the trend.<br />
              <span style=${red}>Red color： Up trend</span><br />
              <span style=${green}>Green color：Down trend</span><br />
              <span style=${blue}>Blue color： No trend</span>`,
        position: isMobile ? `auto` : `right`,
        returnToTop: true,
      },
      {
        page: `SIMILAR_CHART`,
        element: `.rankingIcon`,
        intro: `The chart shapes are displayed in descending order of similarity.<br />
              If <span style=${red}>red</span> is placed at the top and <span style=${green}>green</span> is placed at the bottom, it indicates an upward trend.<br />
              on the other hand, <span style=${green}>green</span> is placed at the top and <span style=${red}>red</span> is placed at the bottom, it indicates an upward trend.`,
        position: isMobile ? `auto` : `left`,
      },
    ],
  }
  return message[locale]
}
